export default {
  title: 'Personal Info',
  actions: {
    clients: {
      title: 'Polaris Clients',
    },
    shoshana: {
      title: 'Shoshana Sharon Shahor Clients',
    },
    guy: {
      title: 'Guy Even Tov Clients',
    },
    itchik: {
      title: 'Itzik Tobi Clients',
    },
  },
};
